<template>
    <div :class="['project-thumb', data.type, isHover && 'is-hover']">
        <LinkHover
            :class="['content', 'main-content', isHover && 'is-hover']"
            :hover-enable="false"
            :type="'router-link'"
            ref="linkable"
            :to="$trl({
                name: routeName,
                params: {
                    slug: data.customslug || data.slug,
                    locale: $route.params.locale
                },
                meta: {
                    customSlug: !!data.customSlug
                }
            })"
        >
            <div class="default">
                <div class="headline" v-if="data.locationdetails || country">
                    <IconPin :color="'#646873'" class="pin"/> {{data.locationdetails || country.name}}
                </div>
                <div class="container">
                    <div class="sizer">
                        <IconPlus class="plus"/>
                        <h2>{{data.name}}</h2>
                        <p
                            class="description"
                            v-if="data.baseline"
                            v-html="data.baseline"
                        ></p>
                    </div>
                </div>
                <div class="baseline" v-if="market">
                    {{$t('common.market')}}{{$i18n.locale !== 'en' ?  ' ' : ''}}: {{market.name}}
                </div>
            </div>
            <template v-slot:hover>
                <span
                    class="hover"
                >
                    <div class="headline" v-if="data.locationdetails || country">
                        <IconPin :color="'#ffffff'" class="pin"/> {{data.locationdetails || country.name}}
                    </div>
                    <div class="container">
                        <div class="sizer">
                            <IconPlus class="plus"/>
                            <h2>{{data.name}}</h2>
                            <p
                                class="description"
                                v-if="data.baseline"
                                v-html="data.baseline"
                            ></p>
                        </div>
                    </div>
                    <div class="baseline" v-if="market">
                        {{$t('common.market')}}{{$i18n.locale !== 'en' ?  ' ' : ''}}: {{market.name}}
                    </div>
                </span>
            </template>
        </LinkHover>
        <div class="content">
            <div class="image-gabarit">
                <div class="image-sizer">
                    <Parallax
                        class="image-holder"
                        :effect="'translateY'"
                        :power="0.1"
                    >
                        <div
                            class="image-box"
                            :style="{
                                backgroundImage: `url(${data.image.url})`
                            }"
                        />
                        <img
                            :src="data.image.url"
                            :alt="data.image.alt"
                            :title="data.image.title"
                            class="seo-image"
                        />
                    </Parallax>
                </div>
            </div>
            <div class="cta-container">
                <Cta
                    :type="'router-link'"
                    :to="$trl({
                        name: routeName,
                        params: {
                            slug: data.customslug || data.slug,
                            locale: $route.params.locale
                        },
                        meta: {
                            customSlug: !!data.customSlug
                        }
                    })"
                    :class="['link', {'is-hover' : isHover}]"
                    @mouseenter.native="handleTouchstart"
                    @mouseleave.native="handleTouchend"
                >
                    {{ data.type === 'project' ? $t('cta.see.project') : $t('cta.see.technique') }}
                </Cta>
            </div>
        </div>
    </div>
</template>

<script>
import IconPin from '@/components/IconPin'
import IconPlus from '@/components/IconPlus'
import LinkHover from '@/components/animation/LinkHover'
import Parallax from '@/components/animation/Parallax'
import Cta from '@/components/Cta'
export default {
    components: {
        IconPin,
        IconPlus,
        LinkHover,
        Cta,
        Parallax
    },
    props: {
        data: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            isHover: false
        }
    },
    mounted() {
        // console.log(this.$refs)
        this.$refs.linkable.$el.addEventListener(this.interaction.active, this.handleTouchstart)
        this.$refs.linkable.$el.addEventListener(this.interaction.unactive, this.handleTouchend)
    },
    destroyed() {
        this.$refs.linkable.$el.removeEventListener(this.interaction.active, this.handleTouchstart)
        this.$refs.linkable.$el.removeEventListener(this.interaction.unactive, this.handleTouchend)
    },
    computed:
    {
        routeName() {
            return this.data.type === 'technique' ? 'Technique' : 'Project'
        },
        country() {
            const country = this.data.related_posts ? this.data.related_posts.find(_ => _.type === 'country') : null
            return country
        },
        market() {
            const market = this.data.related_posts ? this.data.related_posts.find(_ => _.type === 'market') : null
            return market
        }
    },
    methods: {
        handleTouchstart() {
            this.isHover = true
        },
        handleTouchend() {
            this.isHover = false
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.project-thumb
    display: flex
    @include media-breakpoint-down($lg)
        flex-direction: column
    @media print
        page-break-inside: avoid
        break-inside: avoid
        display: block
        margin-bottom: 1.2cm
    &+.project-thumb
        margin-top: 4.25%
        @media print
            margin-top: 1.2cm
.content
    flex: 1
    width: 50%
    display: flex
    flex-direction: column
    @include media-breakpoint-down($lg)
        width: auto
    @media print
        width: auto
        &.main-content:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
            display: block
.headline
    color: #636772
    font-size: 28px
    font-weight: 500
    display: flex
    align-items: center
    padding-left: 23%
    padding-top: 6.825%
    padding-bottom: 6.825%
    position: relative
    @include media-breakpoint-down($sm)
        font-size: 17px
        padding-left: 9.6%
    @media print
        font-size: 17px
        padding-top: 0cm
        padding-bottom: 0cm
        padding-left: 0
    &:after
        content: ""
        display: block
        height: 2px
        background-image: url('./../assets/circle.svg')
        background-repeat: repeat-x
        background-size: 12px
        background-position: 0 50%
        position: absolute
        left: 0
        right: 0
        bottom: 0
        margin-left: -12%
        padding-left: 12%
        opacity: 0.3
.container
    padding-left: 23%
    padding-top: 6.825%
    padding-bottom: 6.825%
    padding-right: 7%
    position: relative
    @include media-breakpoint-down($sm)
        padding-left: 9.6%
    @media print
        padding-top: .15cm
        padding-bottom: .15cm
        padding-left: 0
        padding-right: 0
    .technique &
        padding-bottom: 13.875%
        padding-top: 9.25%
        @media print
            padding-top: .15cm
            padding-bottom: .15cm
            padding-left: 0
            padding-right: 0
.sizer
    position: relative
.baseline
    color: #ff2b2a
    font-size: 28px
    font-weight: 500
    padding-left: 23%
    padding-top: 6.25%
    padding-bottom: 9%
    position: relative
    @include media-breakpoint-down($sm)
        font-size: 17px
        padding-left: 9.6%
    @media print
        padding-top: .15cm
        padding-bottom: .15cm
        padding-left: 0
        padding-right: 0
    &:before
        content: ""
        display: block
        height: 2px
        background-image: url('./../assets/circle.svg')
        background-repeat: repeat-x
        background-size: 12px
        background-position: 0 50%
        position: absolute
        left: 0
        right: 0
        top: 0
        margin-right: -112.625%
        margin-left: -12.625%
        padding-left: 12.625%
        opacity: 0.3
h2
    color: #ff2b2a
    font-size: 4.4791666667vw
    font-weight: 500
    line-height: 1
    letter-spacing: -0.05813953488em
    white-space: initial
    // padding-right: 10%
    word-wrap: break-word
    .technique &
        [lang="es"] &
            font-size: 3.625vw
    @include media-breakpoint-up($xxl)
        font-size: 86px
    @include media-breakpoint-down($hd)
        font-size: 50px
    @include media-breakpoint-down($sm)
        font-size: 36px
    @media print
        font-size: 36px
    &+.description
        margin-top: 6.25%
        @media print
            margin-top: .15cm
.description
    font-size: 28px
    line-height: 1.36
    max-height: 5 * 1.36em
    overflow: hidden
    display: -webkit-box
    -webkit-line-clamp: 5
    -webkit-box-orient: vertical
    padding-right: 25%
    @include media-breakpoint-down($lg)
        height: auto
    @include media-breakpoint-down($sm)
        font-size: 17px
        padding-right: 0
    @media print
        height: auto
        margin-top: .15cm
        margin-bottom: .15cm
        padding-left: 0
        padding-right: 0
    .technique &
        padding-right: 20%
        -webkit-line-clamp: initial
        height: auto
.pin
    margin-right: .625em
.plus
    position: absolute
    right: 100%
    margin-right: 15.5%
    top: 43px
    transform: translateX(50%) translateY(-50%)
    @include media-breakpoint-down($sm)
        display: none
    @media print
        display: none
    /deep/ path
        fill: #ff2b2a
.default
    border: 1px solid #e0e1e3
    width: 100%
    @media print
        border: none
.hover
    border: 1px solid #ff2b2a
    background: #ff2b2a
    width: 100%
    .headline
        color: #ffffff
    h2
        color: #ffffff
    .plus
        /deep/ path
            fill: #ffffff
    .description
        color: #ffffff
    .baseline
        color: #ffffff

.image-sizer
    padding-bottom: 48.623853211%
    height: 0
    overflow: hidden
    position: relative
.image-holder
    position: absolute
    top: -10%
    right: 0
    bottom: -10%
    left: 0
.image-box
    width: 100%
    height: 100%
    background-position: 50% 50%
    background-size: cover
    background-repeat: no-repeat

// img
//     width: 100%
//     height: auto
//     display: block
.image-gabarit
    flex: 1
    @media print
        display: none
.cta-container
    padding-top: 6%
    padding-bottom: 6%
    padding-left: 25%
    display: flex
    @include media-breakpoint-down($sm)
        padding-left: 0
        justify-content: center
    @media print
        display: none
    .technique &
        padding-top: 9%
    .link
        border: 1px solid #e5e5e5
a
    // font-size: 17px
    // font-weight: 500
    // color: #636776
    // border: 1px solid #e5e5e5
    // line-height: 1.6470588235
    // padding: 2.875% 7%
    // border-radius: 4px
    text-decoration: none
// .arrow
//     vertical-align: middle
//     margin-left: -4%
//     margin-right: 2%
//     /deep/ path
//         fill: #636776
</style>
